import React from "react";
import Card from "react-bootstrap/Card";
import { useTranslation } from "../../i18n";

function AboutCard() {
  const { t } = useTranslation();

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            {t("about.greeting")}{" "}
            <span className="purple">{t("about.name")}</span>
            {t("about.from")}{" "}
            <span className="purple">{t("about.location")}</span>.
            <br />
            {t("about.workingAs")}{" "}
            <span className="purple">{t("about.role")}</span>{" "}
            {t("about.at")}{" "}
            <span className="purple">{t("about.company")}</span>
            {t("about.seeking")}{" "}
            <span className="purple">{t("about.targetRole")}</span>{" "}
            {t("about.seekingEnd")}
            <br />
            {t("about.degreePrefix")}{" "}
            <span className="purple">{t("about.degree")}</span>
            {t("about.college") ? (
              <>
                {" "}
                {t("about.degreeFrom")}{" "}
                <span className="purple">{t("about.college")}</span>
              </>
            ) : (
              <> {t("about.degreeFrom")}</>
            )}
            .
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
